<p-card [header]="title | translate" [style]="{ width: '500px' }">
  <p>{{ message | translate }}</p>
  <ng-template pTemplate="footer">
    <p-button [label]="'auth.back' | translate" (click)="onHome()"></p-button>
  </ng-template>
</p-card>
